/* eslint-disable eslint-comments/disable-enable-pair, no-magic-numbers */
import {
  ADD_KEYWORD_AUTOCOMPLETE_CUSTOM_TOKEN,
  ADD_KEYWORD_AUTOCOMPLETE_TOKEN,
  ADD_WORKPLACE_AUTOCOMPLETE_CUSTOM_TOKEN,
  ADD_WORKPLACE_AUTOCOMPLETE_TOKEN,
  CHECK_RADIUS,
  GENERATE_KEYWORD_AUTOCOMPLETE_TOKENS,
  GENERATE_WORKPLACE_AUTOCOMPLETE_TOKENS,
  REMOVE_KEYWORD_AUTOCOMPLETE_TOKEN,
  REMOVE_WORKPLACE_AUTOCOMPLETE_TOKEN,
  SET_AUTOCOMPLETE_LATEST_SEARCH,
  SET_RADIUS,
  SET_SEARCH_PARAMS,
  SHOW_KEYWORD_AUTOCOMPLETE_LATEST,
  SHOW_WORKPLACE_AUTOCOMPLETE_LATEST,
  UPDATE_KEYWORD_AUTOCOMPLETE_SUGGESTIONS,
  UPDATE_KEYWORD_AUTOCOMPLETE_VALUE,
  UPDATE_WORKPLACE_AUTOCOMPLETE_SUGGESTIONS,
  UPDATE_WORKPLACE_AUTOCOMPLETE_VALUE
} from 'src/redux/constant/actionsType';


const setSearchParameters = (state = {}) => ({
  type: SET_SEARCH_PARAMS,
  state
});
const addWorkplaceAutocompleteToken = (state = {}) => ({
  type: ADD_WORKPLACE_AUTOCOMPLETE_TOKEN,
  state
});
const addWorkplaceAutocompleteCustomToken = (state = '') => ({
  type: ADD_WORKPLACE_AUTOCOMPLETE_CUSTOM_TOKEN,
  state
});
const removeWorkplaceAutocompleteToken = (state = -1) => ({
  type: REMOVE_WORKPLACE_AUTOCOMPLETE_TOKEN,
  state
});
const updateWorkplaceAutocompleteSuggestions = (state = {}) => ({
  type: UPDATE_WORKPLACE_AUTOCOMPLETE_SUGGESTIONS,
  state
});
const addKeywordAutocompleteToken = (state = {}) => ({
  type: ADD_KEYWORD_AUTOCOMPLETE_TOKEN,
  state
});
const addKeywordAutocompleteCustomToken = (state = '') => ({
  type: ADD_KEYWORD_AUTOCOMPLETE_CUSTOM_TOKEN,
  state
});
const removeKeywordAutocompleteToken = (state = -1) => ({
  type: REMOVE_KEYWORD_AUTOCOMPLETE_TOKEN,
  state
});
const updateKeywordAutocompleteSuggestions = (state = {}) => ({
  type: UPDATE_KEYWORD_AUTOCOMPLETE_SUGGESTIONS,
  state
});
const setAutocompleteLatestSearch = (state = {}) => ({
  type: SET_AUTOCOMPLETE_LATEST_SEARCH,
  state
});
const showKeywordAutocompleteLatest = () => ({
  type: SHOW_KEYWORD_AUTOCOMPLETE_LATEST
});
const showWorkplaceAutocompleteLatest = () => ({
  type: SHOW_WORKPLACE_AUTOCOMPLETE_LATEST
});
const generateKeywordAutocompleteTokens = () => ({
  type: GENERATE_KEYWORD_AUTOCOMPLETE_TOKENS
});
const generateWorkplaceAutocompleteTokens = (state = {}) => ({
  type: GENERATE_WORKPLACE_AUTOCOMPLETE_TOKENS,
  state
});
const updateWorkplaceAutocompleteValue = (state = '') => ({
  type: UPDATE_WORKPLACE_AUTOCOMPLETE_VALUE,
  state
});
const updateKeywordAutocompleteValue = (state = '') => ({
  type: UPDATE_KEYWORD_AUTOCOMPLETE_VALUE,
  state
});
const setRadiusValue = (state = '') => ({
  type: SET_RADIUS,
  state
});
const checkRadius = () => ({
  type: CHECK_RADIUS
});

export {
  setSearchParameters as setSearchParams,
  addWorkplaceAutocompleteToken,
  addWorkplaceAutocompleteCustomToken,
  removeWorkplaceAutocompleteToken,
  updateWorkplaceAutocompleteSuggestions,
  addKeywordAutocompleteToken,
  addKeywordAutocompleteCustomToken,
  removeKeywordAutocompleteToken,
  updateKeywordAutocompleteSuggestions,
  setAutocompleteLatestSearch,
  showKeywordAutocompleteLatest,
  showWorkplaceAutocompleteLatest,
  generateKeywordAutocompleteTokens,
  generateWorkplaceAutocompleteTokens,
  updateWorkplaceAutocompleteValue,
  updateKeywordAutocompleteValue,
  setRadiusValue,
  checkRadius
};
